import { Overlay } from '@angular/cdk/overlay';
import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

/* @description <div ngxResizable [ngxResizableTargetElement]="'.mat-mdc-dialog-surface'"></div>
* @param ngxResizableTargetElement - string
* @output onResizeStart - EventEmitter<{ width: number; height: number }>
* @output onResize - EventEmitter<{ width: number; height: number }>
* @output onResizeEnd - EventEmitter<{ width: number; height: number }>
*/ 
@Directive({
  selector: '[ngxResizable]',
  standalone: true
})
export class ResizableDirective implements OnDestroy {
  private resizer!: HTMLElement;
  private isResizing = false;
  private startX = 0;
  private startY = 0;
  private startWidth = 0;
  private startHeight = 0;

  @Input() ngxResizableTargetElement: string = '';
  @Input() ngxResizableEventClass: string = 'element-resizing';
  @Input() ngxResizableDisabled: boolean = false;
  
  
  @Output() onResizeStart = new EventEmitter<{ width: number; height: number }>();
  @Output() onResize = new EventEmitter<{ width: number; height: number }>();
  @Output() onResizeEnd = new EventEmitter<{ width: number; height: number }>();

  private removeMouseMoveListener!: () => void;
  private removeMouseUpListener!: () => void;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    if(this.ngxResizableDisabled) return;
    setTimeout(() => {
      // this.setInitialFixedSize()
      this.createResizeHandle();
      
    },500);
  }

  ngOnDestroy(): void {
    this.resizer?.remove();
    this.removeMouseMoveListener?.();
    this.removeMouseUpListener?.();
  }

  private setInitialFixedSize(): void {
  
    // const el = this.ngxResizableTargetElement ? this.renderer.selectRootElement(this.ngxResizableTargetElement) : this.host.nativeElement;
    const el = this.getTargetElement();
    const body = document.body;
    const styles = getComputedStyle(el);

    const width = styles.width;
    const height = styles.height;
    const position = styles.position;

    // Imposta dimensioni fisse iniziali
    this.renderer.setStyle(el, 'width', width);
    this.renderer.setStyle(el, 'height', height);

    

    // Assicura che l'elemento abbia una posizione relativa o assoluta
    if (position === 'static') {
      this.renderer.setStyle(el, 'position', 'absolute');
    }
  }
   /** Recupera l'elemento target (dialog surface o host) */
   private getTargetElement(): HTMLElement {
    if (this.ngxResizableTargetElement) {
      const el = document.querySelector(this.ngxResizableTargetElement);
      if (el instanceof HTMLElement) {
        return el;
      }
    }
    return this.host.nativeElement;
  }

  private createResizeHandle(): void {
   
    // const el = this.host.nativeElement;
    const el = this.getTargetElement();
    const elParent = this.renderer.parentNode(el);
    // this.resizer = this.renderer.selectRootElement('resizer');

    this.resizer = this.renderer.createElement('div');
    this.renderer.addClass(this.resizer, 'resize-handle');

    // Appendi l'handler all'interno
    // this.renderer.insertBefore(elParent, this.resizer, this.host.nativeElement);
    this.renderer.appendChild(el, this.resizer);

    // Applica gli stili
    this.renderer.setStyle(this.resizer, 'width', '16px');
    this.renderer.setStyle(this.resizer, 'height', '16px');
    this.renderer.setStyle(this.resizer, 'position', 'absolute');
    this.renderer.setStyle(this.resizer, 'right', '4px');
    this.renderer.setStyle(this.resizer, 'bottom', '4px');
    // this.renderer.setStyle(this.resizer, 'transform', 'translate(-4px, -100%)');
    this.renderer.setStyle(this.resizer, 'cursor', 'se-resize');
    this.renderer.setStyle(this.resizer, 'background', 'rgba(0,0,0,0)');
    this.renderer.setStyle(this.resizer, 'border-radius', '4px');
    this.renderer.setStyle(this.resizer, 'z-index', '10');
    this.renderer.setStyle(this.resizer, 'border-bottom', '4px solid currentColor');
    this.renderer.setStyle(this.resizer, 'border-right', '4px solid currentColor');

    // Gestione eventi
    this.renderer.listen(this.resizer, 'mousedown', (event: MouseEvent) =>
      this.startResize(event)
    );
    this.removeMouseMoveListener = this.renderer.listen(
      'document',
      'mousemove',
      (event: MouseEvent) => this.onMouseMove(event)
    );
    this.removeMouseUpListener = this.renderer.listen(
      'document',
      'mouseup',
      () => this.stopResize()
    );
  }

  private startResize(event: MouseEvent): void {
    // event.preventDefault();
    // event.stopPropagation(); // evita interferenze con cdkDrag

    const body = document.body;
    body.classList.add(this.ngxResizableEventClass);
    this.isResizing = true;

    this.startX = event.clientX;
    this.startY = event.clientY;
    // const el  = this.ngxResizableTargetElement ? this.renderer.selectRootElement(this.ngxResizableTargetElement) : this.host.nativeElement;;
    const el = this.getTargetElement();
    this.startWidth = el.offsetWidth;
    this.startHeight = el.offsetHeight;

this.onResizeStart.emit({
      width: this.startWidth,
      height: this.startHeight
    });
  }

  private onMouseMove(event: MouseEvent): void {
    if (!this.isResizing) return;
    // event.preventDefault();
    // event.stopPropagation(); // evita interferenze con cdkDrag

    const deltaX = event.clientX - this.startX;
    const deltaY = event.clientY - this.startY;

    const newWidth = this.startWidth + deltaX;
    const newHeight = this.startHeight + deltaY;

    // const el = this.ngxResizableTargetElement ? this.renderer.selectRootElement(this.ngxResizableTargetElement) : this.host.nativeElement;
    const el = this.getTargetElement();
    this.onResize.emit({
      width: newWidth,
      height: newHeight
    })
    this.renderer.setStyle(el, 'width', `${newWidth}px`);
    this.renderer.setStyle(el, 'height', `${newHeight}px`);
  }

  private stopResize(): void {
    const body = document.body;
    body.classList.remove(this.ngxResizableEventClass);
    this.isResizing = false;
  }
}